import { config } from 'aws-sdk'
import S3Client from 'aws-sdk/clients/s3'
import appConfig from '@config'

config.update({
    region: appConfig.AWS_REGION,
    credentials: {
        accessKeyId: appConfig.AWS_ACCESS_KEY_ID,
        secretAccessKey: appConfig.AWS_SECRET_ACCESS_KEY
    },
    mediaconvert: {
        endpoint: appConfig.AWS_MEDIA_CONVERT_ENDPOINT
    }
})

const s3 = new S3Client({
    apiVersion: '2006-03-01',
})
export interface UploadFileOption {
    name: string
    pathToStore: string
}

// ** SAMPLE OUTPUT Result
// {
//     Bucket: "STRING"
//     ETag: "GUID"
//     Key: "KEYPATH"
//     Location: "FULLS3URLFILE"
// }
export const uploadFileAsync = async (file: File, options: UploadFileOption, progressEventCallback: () => void): Promise<any | null> => {
    try {
        const key = options.pathToStore + '/'
        const fileName = options.name // TODO: replace space with dash
        const fileNameKey = key + fileName

        const params = {
            Bucket: appConfig.AWS_BUCKET_INPUT,
            Key: fileNameKey,
            // ACL: 'public-read',
            Body: file
        }

        // call S3 to retrieve upload file to specified bucket 
        const result = await s3
            .upload(params)
            .on('httpUploadProgress', (progress) => {
                const uploaded = (progress.loaded * 100) / progress.total
                progressEventCallback(parseInt(uploaded.toFixed(0)))
            }).promise()

        console.info('Process upload file done: ')
        console.info(result)
        return result
    } catch (err) {
        console.error(`Error occurs during upload file: ${err.message}`)
    }

    return null
}